import {
  FormControlLabel,
  Grid,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import React from "react";
import { connect } from "react-redux";
import { SalesTeamConfigurationJson } from "../../../DynamicFormsJson/MastersJSON/salesTeamConfiguration";
import {
  getAreaByStockStakeHolderTypeIdAndZoneIds,
  getAreaByStockStakeHolderTypeIdAndZoneIdsEdit,
} from "../../../Slice/StackHolder.slice";
import { getAreaByTalukaPostBodyUpdated } from "../../../Slice/area.slice";
import { getDistrictByZone } from "../../../Slice/district.slice";
import { getRegionNew, getZoneByRegion } from "../../../Slice/region.slice";
import {
  getBelowSalesTeamBasicInfo,
  getSalesExecutive,
  getSalesTeamBasicInfoByAreas,
  setTeamList,
} from "../../../Slice/salesExecutive.slice";
import { getStateByRegion } from "../../../Slice/state.slice";
import { getStockStakeHolderType } from "../../../Slice/stockStakeHolderType.slice";
import { getTalukaByDistrictPost } from "../../../Slice/taluka.slice";
import { getZoneByState } from "../../../Slice/zone.slice";
import LandingScreenHeader from "../../../components/Comman/LandingScreenHeader";
import DynamicFormWithoutSave from "../../../components/dynamicscreens/DynamicFormWithoutSave";
import { withRouter } from "../../../components/withRouter";
import { skyBlueNew } from "../../../config/ColorObj";
import endpoint from "../../../config/endpoints";
import {
  noInternetMsg,
  serverMsg,
  updateData,
} from "../../../config/messageconstant";
import { apiPost } from "../../../utils/api_service";
import { showLoador, showNotification } from "../../Landing/Landing.slice";
import { ButtonCompo } from "../../../components/Comman/Button";

class SalesTeamConfiguration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allChecked: false,
      dynamicMasterData: {
        regionDetail: this.props.regionList?.region,
        stateDetail: this.props.stateList?.stateByRegion,
        zoneDetail: this.props.zoneList?.zoneByRegionId,
        districtDetail: this.props.districtList?.districtByZone,
        talukaDetail: this.props.talukaList?.talukaByDistrict,
        areaDetail: this.props.areaList?.areaByTaluka,
        stockHolderTypeDetail:
          this.props.stakeHolderTypeList?.stockStakeHolderType,
        salesPersonDetail: this.props.salesTeamList?.salesExecutive,
      },
      salesTeamId: "",
      searchValue: "",
      sequenceWiseOrder: "0",
      outletEdit: "0",
    };
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.regionList !== nextProps.regionList) {
      if (this.props.regionList?.region !== nextProps.regionList?.region) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            regionDetail: nextProps.regionList?.region,
          },
        });
      }
    }

    if (this.props.stateList !== nextProps.stateList) {
      if (
        this.props.stateList?.stateByRegion !==
        nextProps.stateList?.stateByRegion
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stateDetail: nextProps.stateList?.stateByRegion,
          },
        });
      }
    }

    if (this.props.zoneList !== nextProps.zoneList) {
      if (
        this.props.zoneList?.zoneByState !== nextProps.zoneList?.zoneByState
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            zoneDetail: nextProps.zoneList?.zoneByState,
          },
        });
      }
    }

    if (this.props.districtList !== nextProps.districtList) {
      if (
        this.props.districtList?.districtByZone !==
        nextProps.districtList?.districtByZone
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            districtDetail: nextProps.districtList?.districtByZone,
          },
        });
      }
    }

    if (this.props.talukaList !== nextProps.talukaList) {
      if (
        this.props.talukaList?.talukaByDistrict !==
        nextProps.talukaList?.talukaByDistrict
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            talukaDetail: nextProps.talukaList?.talukaByDistrict,
          },
        });
      }
    }

    if (this.props.areaList !== nextProps.areaList) {
      if (
        this.props.areaList?.areaByTaluka !== nextProps.areaList?.areaByTaluka
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            areaDetail: nextProps.areaList?.areaByTaluka,
          },
        });
      }
    }
    if (this.props.stakeHolderTypeList !== nextProps.stakeHolderTypeList) {
      if (
        this.props.stakeHolderTypeList?.stockStakeHolderType !==
        nextProps.stakeHolderTypeList?.stockStakeHolderType
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stockHolderTypeDetail:
              nextProps.stakeHolderTypeList?.stockStakeHolderType,
          },
        });
      }
    }

    if (this.props.salesTeamList !== nextProps.salesTeamList) {
      if (
        this.props.salesTeamList?.salesExecutive !==
        nextProps.salesTeamList?.salesExecutive
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            salesPersonDetail: nextProps.salesTeamList?.salesExecutive,
          },
        });
      }
    }
  }
  async componentDidMount() {
    const {
      getRegionNew,
      getStockStakeHolderType,
      showLoador,
      showNotification,
    } = this.props;

    const isSalesTeamConfigurationManage = localStorage.getItem(
      "isSalesTeamConfigurationManage"
    );

    this.setState({ isSalesTeamConfigurationManage });

    showLoador({ loador: true });
    await getRegionNew().then(({ response, success }) => {
      showLoador({ loador: false });
      if (!success) {
        showNotification({ msg: serverMsg, severity: "error" });
      }
    });

    showLoador({ loador: true });
    await getStockStakeHolderType({ userTypeIds: "3,4" }).then(
      ({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      }
    );
  }

  getListById = async (data) => {
    const {
      getStateByRegion,
      getZoneByState,
      getDistrictByZone,
      getTalukaByDistrictPost,
      getAreaByTalukaPostBodyUpdated,

      showLoador,
      showNotification,
      getSalesExecutive,
    } = this.props;
    if (navigator.onLine) {
      if (data.currentRegionId && data.currentRegionId != "") {
        showLoador({ loador: true });
        await getStateByRegion({ regionIds: data.currentRegionId }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.currentStateId && data.currentStateId != "") {
        showLoador({ loador: true });
        await getZoneByState({ stateIds: data.currentStateId }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.currentZoneIds && data.currentZoneIds != "") {
        showLoador({ loador: true });
        await getDistrictByZone({ zoneIds: data.currentZoneIds }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.currentDistrictIds && data.currentDistrictIds != "") {
        let districtIdJson = {
          districtIds:
            typeof data.currentDistrictIds === "string"
              ? data.currentDistrictIds.split(",")
              : data.currentDistrictIds,
        };

        showLoador({ loador: true });
        await getTalukaByDistrictPost({ districtIds: districtIdJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }
      if (data.currentTalukaIds && data.currentTalukaIds != "") {
        let talukaJson = {
          talukaIds:
            typeof data.currentTalukaIds === "string"
              ? data.currentTalukaIds.split(",")
              : data.currentTalukaIds,
        };
        showLoador({ loador: true });
        await getAreaByTalukaPostBodyUpdated({ talukaIds: talukaJson }).then(
          ({ success }) => {
            showLoador({ loador: false });
            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            }
          }
        );
      }

      if (data.stockStakeHolderType && data.stockStakeHolderType != "") {
        showLoador({ loador: true });
        await getSalesExecutive({
          stockStakeHolderId: data.stockStakeHolderType,
        }).then(({ success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          }
        });
      }
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearch = (data) => {
    const { getBelowSalesTeamBasicInfo, showLoador, showNotification } =
      this.props;
    if (navigator.onLine) {
      this.setState({
        salesTeamId: data.salesTeamIds,
      });

      showLoador({ loador: true });
      getBelowSalesTeamBasicInfo({
        salesTeamId: data.salesTeamIds.split(","),
      }).then(({ response, success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        } else {
        }
      });
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchForArea = (data) => {
    const {
      getBelowSalesTeamBasicInfo,
      showLoador,
      showNotification,
      areaList,
      salesExecutive,
      getSalesTeamBasicInfoByAreas,
    } = this.props;
    if (navigator.onLine) {
      let dataJson = {
        areaIds: data.currentAreaIds.split(","),
      };

      showLoador({ loador: true });
      getSalesTeamBasicInfoByAreas({ dataJson }).then(
        ({ response, success }) => {
          showLoador({ loador: false });
          if (!success) {
            showNotification({ msg: serverMsg, severity: "error" });
          } else {
          }
        }
      );
    } else {
      this.props.showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  onSearchBox = (searchValue) => {
    this.setState({
      searchValue: searchValue,
    });
  };

  getFilteredTableData = (searchData) => {
    const { searchValue } = this.state;
    return searchData.filter((currentRow) => {
      let isValid = false;
      if (
        (currentRow["name"] &&
          currentRow["name"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["stockStakeHolderTypeName"] &&
          currentRow["stockStakeHolderTypeName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["employeeCode"] &&
          currentRow["employeeCode"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["contactNo"] &&
          currentRow["contactNo"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase())) ||
        (currentRow["userName"] &&
          currentRow["userName"]
            .toString()
            .toLowerCase()
            .includes(searchValue.trim().toLowerCase()))
      ) {
        isValid = true;
        return true;
      }
    });
  };

  handleAllCheckedClick = (e) => {
    const { salesTeamList, setTeamList } = this.props;
    this.setState({ selection: e });
    this.setState({ allChecked: e.target.checked });
    let dataList = salesTeamList?.salesTeamConfiguration.map((dataObj) => {
      return {
        ...dataObj,
        isChecked: e.target.checked,
      };
    });
    setTeamList({ row: dataList });
  };

  handleClick = (e, id) => {
    const { salesTeamList, setTeamList } = this.props;
    this.setState({ selection: e });
    let data = salesTeamList?.salesTeamConfiguration.map((dataObj) => {
      if (dataObj.id == id) {
        return {
          ...dataObj,
          isChecked: e.target.checked,
        };
      } else {
        return dataObj;
      }
    });
    setTeamList({ row: data });
  };

  onSaveForOutletEdit = (status) => {
    const { showNotification, salesTeamList, showLoador } = this.props;
    const { outletEdit, sequenceWiseOrder } = this.state;

    const salesTeamIds = salesTeamList?.salesTeamConfiguration
      .filter((item) => item.isChecked)
      .map((item) => item.id);

    if (!salesTeamIds || salesTeamIds.length == 0) {
      showNotification({
        msg: "Please select at least one record",
        severity: "error",
      });
      return;
    }

    if (navigator.onLine) {
      const dataToSend = {
        salesTeamIds: salesTeamIds,
      };
      swal({
        title: "Are you sure?",
        text: updateData,
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          showLoador({ loador: true });
          apiPost({
            url:
              endpoint.salesExecutive +
              "/update-outlet-edit-and-sequance-wise-order-by-sales-team-ids-by-flag?" +
              "outletEdit=" +
              outletEdit +
              "&sequanceWiseOrder=" +
              sequenceWiseOrder +
              "&flag=" +
              status,
            postBody: dataToSend,
          }).then(({ response, success }) => {
            showLoador({ loador: false });

            if (!success) {
              showNotification({ msg: serverMsg, severity: "error" });
            } else {
              showNotification({
                msg: "Update successful",
                severity: "success",
              });
              window.location.reload();
            }
          });
        }
      });
    }
  };

  changeHandler = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  render() {
    const { salesTeamList } = this.props;
    const {
      dynamicMasterData,
      stockStakeHolderName,
      allChecked,
      calculatedBy,
    } = this.state;

    const isSalesTeamConfigurationManage = localStorage.getItem(
      "isSalesTeamConfigurationManage"
    );

    const tableData = this.getFilteredTableData(
      salesTeamList?.salesTeamConfiguration
    );
    const tableContainerHeight =
      tableData.length === 0
        ? "100px"
        : tableData.length <= 2
          ? "150px"
          : "400px";

    return (
      <>
        <Paper
          sx={{
            padding: 2,
          }}
          elevation={0}
        >
          <DynamicFormWithoutSave
            callBeforeSave={true}
            callBeforeSaveMethod={this.callBeforeSaveMethod}
            formPath={SalesTeamConfigurationJson.formPath}
            showPdfDownload={false}
            showExcelDownload={false}
            showBackToList={false}
            getListById={this.getListById}
            screenTitle={SalesTeamConfigurationJson.screenTitle}
            fieldMeta={
              isSalesTeamConfigurationManage == 0
                ? SalesTeamConfigurationJson.fieldMetaForHeaderHierarchy
                : SalesTeamConfigurationJson.fieldMetaForStockHolderType
            }
            dynamicMasterData={dynamicMasterData}
            apiBaseURL={SalesTeamConfigurationJson.apiBaseURL}
            showSaveNextBtn={SalesTeamConfigurationJson.showSaveNextBtn}
            isEditURL={SalesTeamConfigurationJson.isEditURL}
            showSaveBtnMain={false}
            showSaveBtn={true}
            onSave={
              isSalesTeamConfigurationManage == 0
                ? this.onSearchForArea
                : this.onSearch
            }
            saveBtnText={"Search"}
            showCancel={false}
          />

          {salesTeamList?.salesTeamConfiguration.length !== 0 && (
            <>
              <LandingScreenHeader
                screenTitle={""}
                showSearchBox={true}
                showTable={true}
                showFilter={false}
                showPdfDownload={false}
                showExcelDownload={false}
                onSearch={this.onSearchBox}
              />
              <div
                style={{
                  height: tableContainerHeight,
                  overflowY: "auto",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                }}
              >
                <div style={{ maxHeight: 500, overflow: "auto" }}>
                  <div style={{ height: "400px", overflowY: "auto" }}>
                    <table
                      className="table table-bordered"
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <thead
                        style={{
                          background: skyBlueNew,
                          color: "white",
                          fontSize: "15px",
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          fontWeight: 400,
                        }}
                      >
                        <tr style={{ minHeight: "30px" }}>
                          <th style={{ textAlign: "center" }}>
                            <input
                              type="checkbox"
                              color="red"
                              onClick={(event) =>
                                this.handleAllCheckedClick(event)
                              }
                              checked={allChecked}
                              style={{
                                width: "14px",
                                height: "14px",
                                transform: "scale(1.5)",
                                cursor: "pointer",
                                accentColor: allChecked ? "red" : "skyblue",
                              }}
                            />
                          </th>
                          <th
                            style={{
                              minWidth: "80px",
                              textAlign: "center",
                            }}
                          >
                            Sr. No.
                          </th>
                          <th
                            style={{
                              minWidth: "80px",
                              textAlign: "center",
                            }}
                          >
                            User Name
                          </th>
                          <th
                            style={{
                              minWidth: "200px",
                              textAlign: "center",
                            }}
                          >
                            Sales Team Name
                          </th>
                          <th
                            style={{
                              minWidth: "150px",
                              textAlign: "center",
                            }}
                          >
                            Employee Code
                          </th>
                          <th
                            style={{
                              minWidth: "230px",
                              textAlign: "center",
                            }}
                          >
                            Sales Team Type
                          </th>
                          <th
                            style={{
                              minWidth: "200px",
                              textAlign: "center",
                            }}
                          >
                            Contact Number
                          </th>
                          <th
                            style={{
                              minWidth: "150px",
                              textAlign: "center",
                            }}
                          >
                            Is Outlet Edit
                          </th>
                          <th
                            style={{
                              minWidth: "200px",
                              textAlign: "center",
                            }}
                          >
                            Is Sequence Wise Order
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.getFilteredTableData(
                          salesTeamList?.salesTeamConfiguration
                        ).map((salesTeamData, index) => (
                          <tr
                            key={salesTeamData.id}
                            style={{ fontSize: "14px" }}
                          >
                            <td style={{ textAlign: "center" }}>
                              <input
                                type="checkbox"
                                onClick={(event) =>
                                  this.handleClick(event, salesTeamData.id)
                                }
                                checked={salesTeamData?.isChecked || false}
                                style={{
                                  width: "14px",
                                  height: "14px",
                                  transform: "scale(1.3)",
                                  cursor: "pointer",
                                }}
                              />
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {salesTeamData?.userName || "-"}
                            </td>
                            <td
                              style={{
                                textAlign: "left",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {salesTeamData?.name || "-"}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {salesTeamData?.employeeCode || "-"}
                            </td>
                            <td
                              style={{
                                textAlign: "left",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {salesTeamData?.stockStakeHolderTypeName || "-"}
                            </td>
                            <td
                              style={{
                                textAlign: "center",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {salesTeamData?.contactNo || "-"}
                            </td>

                            <td
                              style={{
                                textAlign: "center",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {salesTeamData?.outletEdit === 1 ? "Yes" : "No"}
                            </td>

                            <td
                              style={{
                                textAlign: "center",
                                padding: "2px",
                                verticalAlign: "middle",
                              }}
                            >
                              {salesTeamData?.sequenceWiseOrder === 1
                                ? "Yes"
                                : "No"}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </>
          )}
          {salesTeamList?.salesTeamConfiguration.length !== 0 && (
            <hr style={{ borderTop: "2px solid #ccc", margin: "10px 0" }} />
          )}



          {salesTeamList?.salesTeamConfiguration.length !== 0 && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <div style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "40px",
                  marginTop: 13,
                  flexWrap: "wrap" // Allows wrapping on smaller screens
                }}>
                  {/* Sequence-Wise Outlet Order */}
                  <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
                    <div style={{
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                      fontSize: '18px',
                      marginTop: '-10px',
                    }}>
                      Sequence-Wise Outlet Order :
                    </div>
                    <RadioGroup
                      row
                      name="sequenceWiseOrder"
                      id="sequenceWiseOrder"
                      value={this.state.sequenceWiseOrder}
                      onChange={this.changeHandler}
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </div>

                  {/* Outlet Edit */}
                  <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
                    <div style={{
                      fontWeight: 500,
                      fontSize: '18px',
                      whiteSpace: "nowrap",
                      marginTop: '-10px',
                    }}>
                      Outlet Edit :
                    </div>
                    <RadioGroup
                      row
                      name="outletEdit"
                      id="outletEdit"
                      value={this.state.outletEdit}
                      onChange={this.changeHandler}
                    >
                      <FormControlLabel
                        value="1"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="0"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </div>

                  {/* Buttons */}
                  {salesTeamList?.salesTeamConfiguration.length !== 0 && (
                    <div style={{
                      display: "flex",
                      gap: "12px",
                      marginLeft: "auto" // Pushes buttons to the right
                    }}>
                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name=" Sequence Wise Order"
                        onClick={(e) => this.onSaveForOutletEdit(2)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name=" Outlet Edit"
                        onClick={(e) => this.onSaveForOutletEdit(1)}
                      />

                      <ButtonCompo
                        size="medium"
                        type="submit"
                        variant="contained"
                        name="Update Both"
                        onClick={(e) => this.onSaveForOutletEdit(0)}
                      />
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
          )}

        </Paper >
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  zoneList: state.zone,
  stakeHolderTypeList: state.stockStakeHolderType,
  salesTeamList: state.salesExecutive,
  regionList: state.region,
  stateList: state.states,
  districtList: state.district,
  talukaList: state.taluka,
  areaList: state.area,
});
const mapDispatchToProps = {
  getRegionNew,
  getZoneByRegion,
  getAreaByStockStakeHolderTypeIdAndZoneIds,
  getAreaByStockStakeHolderTypeIdAndZoneIdsEdit,
  getStockStakeHolderType,
  getStateByRegion,
  getZoneByState,
  getDistrictByZone,
  getTalukaByDistrictPost,
  getAreaByTalukaPostBodyUpdated,
  getSalesExecutive,
  getBelowSalesTeamBasicInfo,
  getSalesTeamBasicInfoByAreas,
  setTeamList,
  showLoador,
  showNotification,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(SalesTeamConfiguration);
